module.exports = __webpack_public_path__ + "img/1457108508.353436fd.jpg";